<template>
  <div class="productos-container">
    <!-- nube de tags para saltar por categoría -->
    <ProductTagCloud :categorias="categorias" />

    <!-- listado de categorías -->
    <div
      v-for="(categoria, index) in categorias"
      :key="index"
      class="categoria-bloque"
    >
      <h1 :id="slugify(categoria.categoria)" class="categoria-titulo">
        {{ categoria.categoria }}
      </h1>

      <div class="grid-productos">
        <div
          v-for="producto in categoria.productos"
          :key="producto.slug"
          class="producto-card"
          :class="{ seleccionado: isSeleccionado(producto) }"
          @click="toggleProducto(producto, categoria.categoria)"
        >
          <img
            :src="producto.imagen"
            :alt="producto.nombre"
            class="producto-img"
          />
          <p class="producto-nombre">{{ producto.nombre }}</p>
        </div>
      </div>
    </div>

    <FloatingCart />
    <ButtonUp />
  </div>
</template>

<script>
import categorias from "@/data/productosAgricola";
import ProductTagCloud from "@/components/ProductTagCloud.vue";
import FloatingCart from "@/components/FloatingCart.vue";
import ButtonUp from "@/components/ButtonUp.vue";
import { useCotizacionStore } from "@/store/cotizacion";

export default {
  name: "RodamientoAgricola",
  components: { ProductTagCloud, FloatingCart, ButtonUp },

  data() {
    return {
      categorias,
    };
  },

  computed: {
    productosSeleccionados() {
      return useCotizacionStore().productosSeleccionados;
    },
  },

  methods: {
    toggleProducto(producto, categoriaNombre) {
      const store = useCotizacionStore();
      const existe = store.productosSeleccionados.some(
        (p) => p.slug === producto.slug
      );
      if (existe) {
        store.removeProducto(producto.slug);
      } else {
        store.addProducto({
          ...producto,
          categoria: categoriaNombre,
        });
      }
    },

    isSeleccionado(producto) {
      return useCotizacionStore().productosSeleccionados.some(
        (p) => p.slug === producto.slug
      );
    },

    slugify(text) {
      return text
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/\//g, "-")
        .replace(/[^\w-]+/g, "");
    },
  },
};
</script>

<style scoped>
.productos-container {
  padding: 3rem 1rem;
  max-width: 1200px;
  margin: auto;
  text-align: center;
}

.categoria-bloque {
  margin-bottom: 5rem;
}

.categoria-titulo {
  font-family: "PlayfairDisplay", serif;
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 2rem;
  position: relative;
  padding-bottom: 1rem;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2), 0 0 2px rgba(0, 0, 0, 0.1);
}
.categoria-titulo::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 250px;
  height: 1px;
  background-color: #00a9e0;
}

.grid-productos {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 2rem;
  padding: 0 1rem;
}

.producto-card {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  cursor: pointer;
  padding: 1.25rem 1rem;
}
.producto-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 8px 24px rgba(0, 169, 224, 1);
}

.producto-img {
  width: 100%;
  max-height: 160px;
  object-fit: contain;
  margin-bottom: 1rem;
  transition: transform 0.3s ease;
}
.producto-card:hover .producto-img {
  transform: scale(1.05);
}

.producto-nombre {
  font-weight: 600;
  font-size: 1.05rem;
  color: #1f1f1f;
  font-family: "PlayfairDisplay", serif;
  transition: color 0.2s;
}
.producto-card:hover .producto-nombre {
  color: #4733ff;
}

.producto-card.seleccionado {
  border: 2px solid #ff6600;
  box-shadow: 0 0 10px rgba(255, 102, 0, 0.8);
  transform: translateY(-6px);
}
</style>
